// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"acab2c54","88":"5782cd98","296":"5782cd98","487":"9615d638","695":"acab2c54","770":"c3fdac37","846":"b82e498f","871":"3fc7f83f","920":"acab2c54"}[chunkId] + ".chunk.css";
};